import styled from 'styled-components';

export const PaginationWrapper = styled.div`
  margin-top: ${(props) => props.theme.spacing.ELEM_SPACING.XXL};
  display: flex;
  justify-content: center;
  font-size: 16px;
  ${(props) => {
    return `
      @media ${props.theme.mediaQuery.medium} {
        font-size: 20px;
      }
      @media ${props.theme.mediaQuery.large} {
        font-size: 24px;
      }
    `;
  }};
`;

export const PaginatorButtonNew = styled.button`
  width: 42px;
  height: 42px;
  border: 1px solid;
  border-radius: 50%;
  color: ${(props) => props.theme.colors.PRIMARY.DARK};
  background: transparent;
  &:disabled {
    color: hsl(0, 0%, 80%);
  }
  &:not(:disabled) {
    cursor: pointer;
  }
`;
export const PaginatedArrow = styled.div`
  color: ${(props) => (props.disabled ? 'hsl(0, 0%, 80%)' : props.theme.colors.PRIMARY.DARK)};
  &:not(:disabled) {
    cursor: pointer;
  }
  &.prev {
    border: solid;
    border-color: inherit;
    border-width: 0 2px 2px 0;
    display: inline-block;
    transform: rotate(135deg);
    -webkit-transform: rotate(135deg);
    padding: 5px;
    margin: 3px 0 0 5px;
  }
  &.next {
    border: solid;
    border-color: inherit;
    border-width: 0 2px 2px 0;
    display: inline-block;
    transform: rotate(-45deg);
    -webkit-transform: rotate(-45deg);
    padding: 5px;
    margin: 3px 8px 0 3px;
  }
`;

export const ContentContainer = styled.div`
  margin: 0px 24px;
  display: flex;
  ${(props) => {
    return `
      @media ${props.theme.mediaQuery.smallMax} {
        margin: 0px 14px;
      }
      @media (max-width: ${props.theme.breakpoints.small}){
        margin: 0px 10px;
      }
    `;
  }};
`;
export const ContentString = styled.span`
  font-size: 16px;
  font-weight: 600;
  font-family: 'Nunito';
  align-self: center;
  ${(props) => {
    return `
      @media (max-width: ${props.theme.breakpoints.small}){
        font-size: 13px;
      }
    `;
  }};
`;
